import React from "react";
import { formatTimestamp } from "./documentUtils";

// Wave 3 — document meta grid (status, perspective paths, timestamps).
const FileMetaGrid = ({
  file,
  isArchived = false,
  perspectiveLabel,
  perspectivePath,
  currentRecipientPath,
  statusTone,
}) => (
  <div className="file-card__meta-grid">
    {isArchived && (
      <div>
        <span>Archive index</span>
        <strong>{file?.archiveIndex || "Legacy archive - index pending"}</strong>
      </div>
    )}
    <div>
      <span>Status</span>
      <strong className={`file-card__status file-card__status--${statusTone}`}>
        {file?.status || "N/A"}
      </strong>
    </div>
    <div>
      <span>{perspectiveLabel}</span>
      <strong>{perspectivePath.join(" • ")}</strong>
    </div>
    <div>
      <span>Uploaded at</span>
      <strong>{formatTimestamp(file?.createdAt)}</strong>
    </div>
    <div>
      <span>Current recipient</span>
      <strong>{currentRecipientPath.join(" • ") || "N/A"}</strong>
    </div>
    {isArchived && (
      <>
        <div>
          <span>Archived at</span>
          <strong>{formatTimestamp(file?.archivedAt)}</strong>
        </div>
        <div>
          <span>Archived by</span>
          <strong>{file?.archivedBy || "N/A"}</strong>
        </div>
      </>
    )}
  </div>
);

export default FileMetaGrid;
